import firebase from 'firebase/app';
import "firebase/analytics";
import 'firebase/auth'; // This line is important
import 'firebase/firestore'; // This line is important
import 'firebase/storage'; 
import 'firebase/functions'; // This line is important
import 'firebase/database'; // This line is important
import  keys from '@/firebase/keys_firebase'

const config = keys.keys.config;
const config_stripe = keys.keys.stripe;
const keysValues = keys.keys;

const const_api = {
	db: null,	
	realDb: null,
	storage: null,
	init(context) {
		 
		this.context = context;
		try {
			const app = firebase.initializeApp(config );
			firebase.analytics();
			this.db = firebase.firestore();
			this.db.settings({
				
				experimentalForceLongPolling: true
			});
			//firebase.firestore.setLogLevel('debug')
			
			this.db.enablePersistence()
				.catch(function(err) {
					if (err.code == 'failed-precondition') {
						console.log("ERROR");
						// Multiple tabs open, persistence can only be enabled
						// in one tab at a a time.
						// ...
					} else if (err.code == 'unimplemented') {
						console.log("ERROR2");
						// The current browser does not support all of the
						// features required to enable persistence
						// ...
					}
					console.log("ERRORTOUT COUR")
				});
			
			//firebase.firestore();	
			
			this.realDb = firebase.database();
			this.storage = firebase.storage().ref();
			// Configuration Analytics
			//const analytics = getAnalytics(app);

		}
		catch(err) {
			
		}
	},
	getConfigStripe() {
		return config_stripe;
	},
	getDb () {
		return this.db;
	},
	getUser() {
		return firebase.auth().currentUser;
	},
	getDate() {
		return firebase.firestore.FieldValue.serverTimestamp();
	},
	setLog(parent, child, error) {
		var logError 	= {};
		logError.parent 	= parent;
		logError.time	= new Date();
		logError.child	= child;
		logError.error	= String(error);
		logError.currentUser = firebase.auth().currentUser.uid;
	
		this.db.collection("log").add(logError)
	},
	sendRecaptcha(reloadCaptcha, recaptcha, fct) {
		if (window.location.hostname == "localhost") {
			var result= {
				data: {
					data: {
						success: true
					}
				}
			}
			fct(result);
		}
		else {
			reloadCaptcha.then(()=>{
				recaptcha.then(token=> {
						var sendRecaptcha = firebase.app().functions('europe-west1').httpsCallable('sendRecaptcha');
						sendRecaptcha({token: token}).then((result)=> {
						// Read result of the Cloud Function.
							fct(result);
						})
						.catch(err=>{
							fct(err);
						})
					})
			})
		}
		
	}
}


export default {
  api: const_api,
  keys: keysValues
};